// @ts-nocheck
export interface ISettingsFrontend {
  Visibility: FrontendVisibility;
}

export enum FrontendVisibility {
  Open,
  Close,
}
